import { FaTelegram } from "react-icons/fa6";
import { type SocialPlatformBaseSettings } from "./types";

export const telegramBaseSettings: SocialPlatformBaseSettings = {
  name: "Telegram",
  icon: FaTelegram,
  fields: {
    caption: "optional",
    userTags: "optional", // In text
  },
  limits: {
    caption: 4096,
    images: 1, // Can be gallery, API might treat differently
    videos: 1,
    // videoDurationSeconds: ??
  },
  notes: ["Caption limit is lower (1024) when sent with media."],
  postTypes: {
    message: {}, // Default message type
  },
};
